import { createBrowserClient } from '@supabase/ssr';
import { Database } from '@tralent/database';

function resolveBrowserSupabaseUrl(value: string) {
	if (process.env.NODE_ENV !== 'development') {
		return value;
	}

	try {
		const url = new URL(value);

		if (url.hostname === 'localhost' && url.port === '54321') {
			url.hostname = '127.0.0.1';
			return url.toString().replace(/\/$/, '');
		}
	} catch {
		return value;
	}

	return value;
}

export const supabaseClient = createBrowserClient<Database>(
	resolveBrowserSupabaseUrl(process.env.NEXT_PUBLIC_SUPABASE_URL!),
	process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
	{
		global: {
			headers: { 'x-tralent-app': 'web' },
		},
	},
);

export const client = supabaseClient;

export async function userSession() {
	try {
		const session = await client.auth.getSession();
		return session.data.session;
	} catch (error) {
		console.log('User Warning ', error);
		return null;
	}
}
